import React from 'react';
import { FloatingLabelInput } from '../common/FloatingLabelInput';
import PasswordRequirements from '../common/PasswordRequirements';

interface PasswordGroupProps {
  password: string;
  setPassword: (value: string) => void;
  passwordStatus: 'default' | 'focus' | 'error' | 'success';
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
  confirmPasswordStatus: 'default' | 'focus' | 'error' | 'success';
  passwordError: string;
  passwordFocused: boolean;
  setPasswordFocused: (v: boolean) => void;
  confirmPasswordFocused: boolean;
  setConfirmPasswordFocused: (v: boolean) => void;
}

const PasswordGroup: React.FC<PasswordGroupProps> = ({
  password,
  setPassword,
  passwordStatus,
  confirmPassword,
  setConfirmPassword,
  confirmPasswordStatus,
  passwordError,
  setPasswordFocused,
  setConfirmPasswordFocused,
}) => (
  <div className="mb-1 grid grid-cols-1 items-start md:grid-cols-[1fr_220px] md:gap-4">
    <div>
      <FloatingLabelInput
        label="Password"
        type="password"
        value={password}
        onChange={e => setPassword(e.target.value)}
        required
        status={passwordStatus}
        onFocus={() => setPasswordFocused(true)}
        onBlur={() => setPasswordFocused(false)}
        className="mt-0 md:mt-0"
      />
      <FloatingLabelInput
        label="Confirm Password"
        type="password"
        value={confirmPassword}
        onChange={e => setConfirmPassword(e.target.value)}
        required
        status={confirmPasswordStatus}
        onFocus={() => setConfirmPasswordFocused(true)}
        onBlur={() => setConfirmPasswordFocused(false)}
        className="mt-2 md:mt-4"
      />
      {/* Show requirements below password on mobile only */}
      <div className="mt-2 md:hidden">
        <PasswordRequirements password={password} />
      </div>
      {/* Show confirm password error below confirm input on mobile only */}
      {passwordError && (
        <div className="mt-1 text-xs text-gray-500 dark:text-gray-400 md:hidden md:text-sm">
          {passwordError}
        </div>
      )}
    </div>
    {/* On md+, show requirements and error in right column, vertically centered */}
    {password && (
      <div className="hidden min-h-[100px] flex-col justify-center md:flex">
        <PasswordRequirements password={password} />
        {passwordError && (
          <span className="mt-2 text-xs text-gray-500 dark:text-gray-400 md:text-xs">
            {passwordError}
          </span>
        )}
      </div>
    )}
  </div>
);

export default PasswordGroup;
